<!-- Search or create applicant-->
<div class="flex flex-col gap-[1rem]">
  <mat-card appearance="outlined">
    <mat-card-content>

      <mat-form-field appearance="outline" class="no-bottom flex-1">
        <mat-label translate="">Applicant name</mat-label>
        <div matSuffix="" class="flex items-center">
          @if (isSearchingApplicants === true) {
            <mat-spinner diameter="14" class="mx2"></mat-spinner>
          }
        </div>
        <input [formControl]="applicantSearchGroup.get('customer')" type="text" matInput="" [matAutocomplete]="customerAutoComplete" #applicantSearchInput="" class="customer-autocomplete-material-input" autocomplete="off">
        <mat-autocomplete autoActiveFirstOption="" #customerAutoComplete="matAutocomplete" [displayWith]="displayApplicantSearchResult">
          @for (applicantSearchResult of applicantSearchResults; track applicantSearchResult) {
            <mat-option [value]="applicantSearchResult">
              @if (applicantSearchResult.customerSearchResult) {
                @if (applicantSearchResult.customerSearchResult.type === 'Person') {
                  <mat-icon class="icon-small mr1">person_outline</mat-icon>
                }
                @if (applicantSearchResult.customerSearchResult.type === 'Company') {
                  <mat-icon class="icon-small mr1">business_center</mat-icon>
                }
                @if (applicantSearchResult.customerSearchResult.type === 'Collaboration') {
                  <mat-icon class="icon-small mr1">people_outline</mat-icon>
                }
                {{applicantSearchResult.customerSearchResult.name}} @if (applicantSearchResult.customerSearchResult.email) {
                <span class="gray">({{applicantSearchResult.customerSearchResult.email}})</span>
              }
            }
            @if (applicantSearchResult.companySearchResult) {
              <mat-icon class="icon-small mr1">add</mat-icon>
              {{ applicantSearchResult.name }}
            }
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <div class="flex justify-center content-center items-center">
      <unite-loading-button class="ml1" style="height: 50px; width: 150px;" icon="add" color="primary" [disabled]="!canAddApplicant()" [loading]="isAddingApplicant" (click)="addApplicant()" [text]="'Add' | translate">
      </unite-loading-button>
    </div>

  </mat-card-content>
</mat-card>


<mat-accordion multi="true" class="basis-full">

  @for (applicant of applicants; track applicant) {
    <mat-expansion-panel [expanded]="!applicant.isProcessed && !applicant.isProcessing" [hideToggle]="!applicant.isProcessed" (opened)="applicant.isProcessed = false" [disabled]="!applicant.isProcessed">
      @if (applicant.type !== 'New' || applicant.isProcessing) {
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="flex justify-between content-center items-center flex-row basis-full">
              <div class="flex flex-row justify-start content-center items-center h-full">
                <div>
                  <h3 [ngClass]="{ 'gray': applicant.isProcessed, 'black' : !applicant.isProcessed, 'pulsate': applicant.isProcessing }">
                    @if (applicant.name) {
                      {{ applicant.name }}
                    }
                  </h3>
                </div>
                <div class="ml1">
                  @if (applicant.isProcessing) {
                    <mat-spinner diameter="18"></mat-spinner>
                  }
                  @if (applicant.isProcessed) {
                    <mat-icon class="green">check</mat-icon>
                  }
                </div>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
      }
      @if (applicant.type === 'New') {
        <div>
          <div class="basis-full">
            <form [formGroup]="applicant.form">
              <h3 translate="" [translateParams]="{ value: applicant.name }">Is ... a company?</h3>
              <mat-radio-group [formControl]="applicant.form.get('customerType')" class="flex gap-[1rem]">
                <mat-radio-button [value]="'Company'">{{ 'Yes' | translate }}</mat-radio-button>
                <mat-radio-button [value]="'Person'">{{ 'No' | translate }}</mat-radio-button>
              </mat-radio-group>
              @if (applicant.form.get('customerType')?.value === 'Person') {
                <h3 translate="" [translateParams]="{ value: applicant.name }">Does ... own dutch real estate?</h3>
                <mat-radio-group [formControl]="applicant.form.get('ownsDutchRealEstate')" class="flex gap-[1rem]">
                  <mat-radio-button [value]="true">{{ 'Yes' | translate }}</mat-radio-button>
                  <mat-radio-button [value]="false">{{ 'No' | translate }}</mat-radio-button>
                </mat-radio-group>
                @if (applicant.form.get('ownsDutchRealEstate')?.value) {
                  <h3 translate="" [translateParams]="{ value: applicant.name }">Enter an address ... owns</h3>
                  <div class="flex justify-start content-center items-center">
                    <div class="flex-1">
                      <unite-address-input-v2 formGroupName="address" disableManualEnter="true">
                      </unite-address-input-v2>
                    </div>
                    <div>
                      <unite-loading-button [loading]="$any(applicant).isRetrievingBuildingOwners" [disabled]="!applicant.form.get('address')?.valid" [text]="'Find owners' | translate" (click)="retrievePossibleApplicants($any(applicant))" style="max-width: 150px;" icon="search" color="primary">
                      </unite-loading-button>
                    </div>
                  </div>
                }
                @if ($any(applicant).buildingOwners) {
                  <h3 translate="" [translateParams]="{ value: applicant.name }">Select the owners that will apply for financing</h3>
                  <div class="flex flex-col">
                    @for (person of $any(applicant).buildingOwners.persons; track person) {
                      <div class="flex flex-row justify-start content-center items-center w-full gap-[1rem]">
                        <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? $any(applicant).selectBuildingOwnerPerson(person) : null" [checked]="$any(applicant).isSelectedBuildingOwnerPerson(person)">
                          {{ person.fullName }}
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                }
              }
            </form>
          </div>
        </div>
      }
      @if (applicant.type === 'Company') {
        <div>
          <div class="basis-full">
            <form [formGroup]="applicant.form" class="flex flex-col">
              <mat-list class="smaller-list medium">
                <mat-list-item [class.warn]="showValidationError(applicant.form.get('name'))">
                  <label translate="">Name</label>
                  <mat-form-field floatLabel="never" class="inline-field">
                    <span class="placeholder">
                      {{applicant.form.get('name')?.value !== null ? applicant.form.get('name')?.value : "..."}}
                    </span>
                    <input matInput="" type="text" [formControl]="applicant.form.get('name')" autocomplete="off">
                  </mat-form-field>
                </mat-list-item>
                <unite-list-item-input type="text" [label]="'Chamber of commerce number' | translate" [control]="applicant.form.get('chamberOfCommerceNumber')">
                </unite-list-item-input>
                <mat-list-item [class.warn]="showValidationError(applicant.form.get('legalForm'))">
                  <label translate="">Legal form</label>
                  <mat-form-field class="inline-field" floatLabel="never" hideRequiredMarker="">
                    <mat-label class="black">...</mat-label>
                    <mat-select [formControl]="applicant.form.get('legalForm')">
                      <mat-option [value]="null"><span translate="">None</span></mat-option>
                      <mat-option [value]="'SoleProprietorship'"><span translate="">SoleProprietorship</span></mat-option>
                      <mat-option [value]="'PrivateCompany'"><span translate="">PrivateCompany</span></mat-option>
                      <mat-option [value]="'LimitedCompany'"><span translate="">LimitedCompany</span></mat-option>
                      <mat-option [value]="'LimitedPartnership'"><span translate="">LimitedPartnership</span></mat-option>
                      <mat-option [value]="'PartnershipUnderFirm'"><span translate="">PartnershipUnderFirm</span></mat-option>
                      <mat-option [value]="'Partnership'"><span translate="">Partnership</span></mat-option>
                      <mat-option [value]="'Cooperation'"><span translate="">Cooperation</span></mat-option>
                      <mat-option [value]="'Association'"><span translate="">Association</span></mat-option>
                      <mat-option [value]="'Foundation'"><span translate="">Foundation</span></mat-option>
                    </mat-select>
                  </mat-form-field>
                </mat-list-item>
                <mat-list-item [class.warn]="showValidationError(applicant.form.get('address'))">
                  <label translate="">Address</label>
                  <unite-address-input-v2 style="max-width: 600px; width: 100%!important;" class="inline-field" appearance="none" formGroupName="address">
                  </unite-address-input-v2>
                </mat-list-item>
                <!-- <mat-list-item [class.warn]="!applicant.getContact() && applicant.form.touched">
                <label  translate>Contact</label>
                <mat-form-field style="margin-bottom: -1.25px" appearance="none" class="inline-field contact-input-none">
                  <input matInput type="text" [formControl]="applicant.form.get('contact.name')" placeholder="..." readonly>
                </mat-form-field>
              </mat-list-item>
              <mat-list-item *ngIf="applicant.shareholders.length === 0">
                <label [class.warn]="applicant.shareholders.length === 0 && applicant.form.touched" translate>UBO</label>
                ...
              </mat-list-item>
              <ng-container *ngIf="applicant.shareholders.length > 0">
                <mat-list-item class="mt2">
                  <label></label>
                  <span>
                    <div><strong translate>UBO's</strong></div>
                  </span>
                </mat-list-item>
                <mat-divider></mat-divider>
                <mat-list-item *ngFor="let shareholder of applicant.shareholders; let i = index">
                  <label>UBO {{ i + 1 }}</label>
                  <span>{{shareholder.name}} ({{shareholder.share }}%)</span>
                </mat-list-item>
              </ng-container> -->
            </mat-list>
            <mat-list class="smaller-list xxl-labels medium">
              @if ($any(applicant).shareholders.length > 0 && !$any(applicant).getContact() && applicant.form.touched) {
                <mat-list-item><label class="warning" translate="">Please mark an UBO as the primary contact</label></mat-list-item>
              }
              @if ($any(applicant).shareholders.length === 0 && applicant.form.touched) {
                <mat-list-item><label class="warning" translate="">Please add UBOs</label></mat-list-item>
              }
            </mat-list>
          </form>
        </div>
      </div>
    }
    @if (applicant.type === 'Person') {
      <div>
        <div class="basis-full">
          <form [formGroup]="applicant.form" class="flex flex-col">
            <div class="flex flex-row flex-wrap">
              <div class="basis-1/2">
                <mat-list class="smaller-list medium">
                  <mat-list-item [class.warn]="showValidationError(applicant.form.get('gender'))">
                    <label translate="">Gender</label>
                    <mat-form-field class="inline-field" floatLabel="never" hideRequiredMarker="">
                      <mat-label class="black">...</mat-label>
                      <mat-select [formControl]="applicant.form.get('gender')">
                        <mat-option [value]="'Male'"><span translate="">Male</span></mat-option>
                        <mat-option [value]="'Female'"><span translate="">Female</span></mat-option>
                      </mat-select>
                    </mat-form-field>
                  </mat-list-item>
                  <unite-list-item-input type="text" [label]="'Initials' | translate" [control]="applicant.form.get('initials')">
                  </unite-list-item-input>
                  <unite-list-item-input type="text" [label]="'First name' | translate" [control]="applicant.form.get('firstName')">
                  </unite-list-item-input>
                  <unite-list-item-input type="text" [label]="'Middle name' | translate" [control]="applicant.form.get('middleName')">
                  </unite-list-item-input>
                  <unite-list-item-input type="text" [label]="'Surname' | translate" [control]="applicant.form.get('surname')">
                  </unite-list-item-input>
                  <unite-list-item-input type="date" [label]="'Birthdate' | translate" [control]="applicant.form.get('birthdate')">
                  </unite-list-item-input>
                </mat-list>
              </div>
              <div class="basis-1/2">
                <mat-list class="smaller-list medium">
                  <mat-list-item [class.warn]="showValidationError(applicant.form.get('address'))">
                    <label translate="">Address</label>
                    <unite-address-input-v2 style="max-width: 600px; width: 100%!important;" class="inline-field" appearance="none" formGroupName="address">
                    </unite-address-input-v2>
                  </mat-list-item>
                  <mat-list-item [class.warn]="showValidationError(applicant.form.get('nationality'))">
                    <label translate="">Nationality</label>
                    <unite-nationality-autocomplete showPlaceholder="true" [control]="applicant.form.get('nationality')" class="inline-field" appearance="none">
                    </unite-nationality-autocomplete>
                  </mat-list-item>
                  <mat-list-item [class.warn]="showValidationError(applicant.form.get('maritalStatus'))">
                    <label translate="">Marital status</label>
                    <unite-maritalstatus-input showPlaceholder="true" [control]="applicant.form.get('maritalStatus')" class="inline-field" appearance="none" hideRequiredMarker="true">
                    </unite-maritalstatus-input>
                  </mat-list-item>
                  @if (hasTaxPartner($any(applicant))) {
                    <unite-list-item-select type="boolean" [label]="'Is the taxpartner applicant?' | translate" [control]="$any(applicant).isTaxPartnerApplicantControl">
                    </unite-list-item-select>
                    @if (isTaxPartnerRequired($any(applicant))) {
                      <mat-list-item [class.warn]="showValidationError(applicant.form.get('taxPartner.name'))">
                        <label translate="">Tax partner</label>
                        <mat-form-field (click)="editTaxPartner($any(applicant))" style="margin-bottom: -1.25px" appearance="none" class="inline-field taxpartner-input-none">
                          <input matInput="" type="text" [formControl]="applicant.form.get('taxPartner.name')" placeholder="..." readonly="">
                        </mat-form-field>
                      </mat-list-item>
                    }
                  }
                  <unite-list-item-input type="text" [label]="'Email' | translate" [control]="applicant.form.get('email')">
                  </unite-list-item-input>
                  <unite-list-item-input type="text" [label]="'Phone' | translate" [control]="applicant.form.get('phone')" pattern="((\+\d{8,14})|([0]\d{9}))">
                  </unite-list-item-input>
                </mat-list>
              </div>
              <div class="basis-full">
                <mat-list class="smaller-list xxl-labels medium">
                  <mat-list-item [class.warn]="showValidationError(applicant.form.get('investmentProfile.actInTheExerciseOfProfessionOrBusiness'))">
                    <label translate="">Act in the exercise of a profession or business</label>
                    <mat-form-field class="inline-field" floatLabel="never" hideRequiredMarker="">
                      <mat-label class="black">...</mat-label>
                      <mat-select [formControl]="applicant.form.get('investmentProfile.actInTheExerciseOfProfessionOrBusiness')">
                        <mat-option [value]="true"><span translate="">Yes</span></mat-option>
                        <mat-option [value]="false"><span translate="">No</span></mat-option>
                      </mat-select>
                    </mat-form-field>
                  </mat-list-item>
                  @if (showExtendedInvestmentProfile($any(applicant).person)) {
                    <mat-list-item [class.warn]="showValidationError(applicant.form.get('investmentProfile.numberOfOwnedInvestmentProperties'))">
                      <label translate="">Number of owned rental properties</label>
                      <mat-form-field class="inline-field" floatLabel="never" hideRequiredMarker="">
                        <mat-label class="black">...</mat-label>
                        <mat-select [formControl]="applicant.form.get('investmentProfile.numberOfOwnedInvestmentProperties')">
                          <mat-option [value]="0"><span translate="">0</span></mat-option>
                          <mat-option [value]="1"><span translate="">1</span></mat-option>
                          <mat-option [value]="2"><span translate="">2</span></mat-option>
                          <mat-option [value]="3"><span translate="">3</span></mat-option>
                          <mat-option [value]="6"><span translate="">4 - 6</span></mat-option>
                          <mat-option [value]="10"><span translate="">7 - 10</span></mat-option>
                          <mat-option [value]="999"><span translate="">More than 10</span></mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-list-item>
                    <mat-list-item [class.warn]="showValidationError(applicant.form.get('investmentProfile.yearsOfProfessionalExperienceInRealEstate'))">
                      <label translate="">Years of professional experience in real estate</label>
                      <mat-form-field class="inline-field" floatLabel="never" hideRequiredMarker="">
                        <mat-label class="black">...</mat-label>
                        <mat-select [formControl]="applicant.form.get('investmentProfile.yearsOfProfessionalExperienceInRealEstate')">
                          <mat-option [value]="0"><span translate="">0</span></mat-option>
                          <mat-option [value]="2"><span translate="">1 - 2</span></mat-option>
                          <mat-option [value]="5"><span translate="">3 - 5</span></mat-option>
                          <mat-option [value]="99"><span translate="">More than 5</span></mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-list-item>
                    <mat-list-item [class.warn]="showValidationError(applicant.form.get('investmentProfile.netRentalIncomeFromInvestmentPropertiesPerYear'))">
                      <label translate="">Yearly net rent income from rental properties</label>
                      <mat-form-field class="inline-field" floatLabel="never" hideRequiredMarker="">
                        <mat-label class="black">...</mat-label>
                        <mat-select [formControl]="applicant.form.get('investmentProfile.netRentalIncomeFromInvestmentPropertiesPerYear')">
                          <mat-option [value]="4999"><span translate="">Less than €5.000</span></mat-option>
                          <mat-option [value]="20000"><span translate="">€5.000 - €20.000</span></mat-option>
                          <mat-option [value]="34999"><span translate="">€20.000 - €35.000</span></mat-option>
                          <mat-option [value]="49999"><span translate="">€35.000 - €50.000</span></mat-option>
                          <mat-option [value]="79999"><span translate="">€50.000 - €80.000</span></mat-option>
                          <mat-option [value]="999999"><span translate="">More than €80.000</span></mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-list-item>
                  }
                </mat-list>
              </div>
            </div>
          </form>
        </div>
      </div>
    }
    <mat-action-row
      class="flex w-full"
      [class.justify-between]="applicant.type === 'Company'"
      [class.justify-end]="applicant.type !== 'Company'">
      @if (applicant.type === 'Company') {
        <div>
          <button type="button" mat-stroked-button="" (click)="saveCompanyAndAddApplicantShareholderView($any(applicant))">
            <span translate="">
              Add UBO
            </span>
          </button>
        </div>
      }
      <div class="flex flex-row">
        <button type="button" mat-button="" color="warn" (click)="removeApplicant(applicant)">
          <span translate="">
            Delete
          </span>
        </button>
        <unite-loading-button [disabled]="!applicant.isValid()" icon="done" (click)="saveApplicant(applicant)" [text]="'Save' | translate" color="primary" [loading]="applicant.isProcessing">
        </unite-loading-button>
      </div>
    </mat-action-row>
  </mat-expansion-panel>
  @for (shareholder of $any(applicant).shareholderViews; track shareholder; let i = $index) {
    <mat-expansion-panel [expanded]="!shareholder.isProcessed && !shareholder.isProcessing" [hideToggle]="!shareholder.isProcessed" (opened)="shareholder.isProcessed = false" [disabled]="!shareholder.isProcessed">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="flex justify-between content-center items-center flex-row basis-full">
            <div class="flex flex-row justify-start content-center items-center h-full">
              <div>
                <h3 [ngClass]="{ 'gray': shareholder.isProcessed, 'black' : !shareholder.isProcessed, 'pulsate': shareholder.isProcessing }">
                  @if (shareholder.name) {
                    {{ shareholder.name }} (UBO {{ applicant.name }})
                  }
                </h3>
              </div>
              <div class="ml1">
                @if (shareholder.isProcessing) {
                  <mat-spinner diameter="18"></mat-spinner>
                }
                @if (shareholder.isProcessed) {
                  <mat-icon class="green">check</mat-icon>
                }
              </div>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="basis-full">
        @if (!shareholder.form) {
          <div class="flex flex-row">
            <unite-customer-autocomplete type="Person" [label]="'Name of UBO' | translate" [control]="shareholder.search.get('customer')" class="flex-1">
            </unite-customer-autocomplete>
            <div class="flex flex-row justify-center content-center items-center h-full">
              <unite-loading-button class="ml1" style="height: 50px; width: 150px;" icon="add" color="primary" [loading]="shareholder.isProcessing" (click)="nameShareholder(shareholder, null, true)" [text]="'Add' | translate">
              </unite-loading-button>
            </div>
          </div>
        }
        @if (shareholder.form) {
          <div class="basis-full">
            <form [formGroup]="shareholder.form" class="flex flex-col">
              <div class="flex flex-row flex-wrap">
                <div class="basis-1/2">
                  <mat-list class="smaller-list medium">
                    <mat-list-item [class.warn]="showValidationError(shareholder.form.get('gender'))">
                      <label translate="">Gender</label>
                      <mat-form-field class="inline-field" floatLabel="never" hideRequiredMarker="">
                        <mat-label class="black">...</mat-label>
                        <mat-select [formControl]="shareholder.form.get('gender')">
                          <mat-option [value]="'Male'"><span translate="">Male</span></mat-option>
                          <mat-option [value]="'Female'"><span translate="">Female</span></mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-list-item>
                    <unite-list-item-input type="text" [label]="'Initials' | translate" [control]="shareholder.form.get('initials')">
                    </unite-list-item-input>
                    <unite-list-item-input type="text" [label]="'First name' | translate" [control]="shareholder.form.get('firstName')">
                    </unite-list-item-input>
                    <unite-list-item-input type="text" [label]="'Middle name' | translate" [control]="shareholder.form.get('middleName')">
                    </unite-list-item-input>
                    <unite-list-item-input type="text" [label]="'Surname' | translate" [control]="shareholder.form.get('surname')">
                    </unite-list-item-input>
                    <unite-list-item-input type="date" [label]="'Birthdate' | translate" [control]="shareholder.form.get('birthdate')">
                    </unite-list-item-input>
                  </mat-list>
                </div>
                <div class="basis-1/2">
                  <mat-list class="smaller-list medium">
                    <mat-list-item [class.warn]="showValidationError(shareholder.form.get('address'))">
                      <label translate="">Address</label>
                      <unite-address-input-v2 style="max-width: 600px; width: 100%!important;" class="inline-field" appearance="none" formGroupName="address">
                      </unite-address-input-v2>
                    </mat-list-item>
                    <mat-list-item [class.warn]="showValidationError(shareholder.form.get('nationality'))">
                      <label translate="">Nationality</label>
                      <unite-nationality-autocomplete showPlaceholder="true" [control]="shareholder.form.get('nationality')" class="inline-field" appearance="none">
                      </unite-nationality-autocomplete>
                    </mat-list-item>
                    <mat-list-item [class.warn]="showValidationError(shareholder.form.get('maritalStatus'))">
                      <label translate="">Marital status</label>
                      <unite-maritalstatus-input showPlaceholder="true" [control]="shareholder.form.get('maritalStatus')" class="inline-field" appearance="none" hideRequiredMarker="true">
                      </unite-maritalstatus-input>
                    </mat-list-item>
                    @if (hasTaxPartner(shareholder)) {
                      <unite-list-item-select type="boolean" [label]="'Is the taxpartner applicant?' | translate" [control]="shareholder.isTaxPartnerApplicantControl">
                      </unite-list-item-select>
                      @if (isTaxPartnerRequired(shareholder)) {
                        <mat-list-item [class.warn]="showValidationError(shareholder.form.get('taxPartner.name'))">
                          <label translate="">Tax partner</label>
                          <mat-form-field (click)="editTaxPartner(shareholder)" style="margin-bottom: -1.25px" appearance="none" class="inline-field taxpartner-input-none">
                            <input matInput="" type="text" [formControl]="shareholder.form.get('taxPartner.name')" placeholder="..." readonly="">
                          </mat-form-field>
                        </mat-list-item>
                      }
                    }
                    <unite-list-item-input type="text" [label]="'Email' | translate" [control]="shareholder.form.get('email')">
                    </unite-list-item-input>
                    <unite-list-item-input type="text" [label]="'Phone' | translate" [control]="shareholder.form.get('phone')" pattern="((\+\d{8,14})|([0]\d{9}))">
                    </unite-list-item-input>
                  </mat-list>
                </div>
              </div>
            </form>
            <mat-list class="smaller-list medium">
              <unite-list-item-select type="boolean" [label]="'Is primary contact' | translate" [control]="shareholder.shareholderForm.get('isContact')">
              </unite-list-item-select>
              <unite-list-item-input type="decimal" [max]="100" [label]="'Share %' | translate" [control]="shareholder.shareholderForm.get('share')">
              </unite-list-item-input>
            </mat-list>
          </div>
        }
      </div>
      <mat-action-row class="flex justify-end content-stretch items-stretch">
        <div class="flex flex-row">
          <button type="button" mat-button="" color="warn" (click)="removeShareholder($any(applicant), shareholder)">
            <span translate="">
              Delete
            </span>
          </button>
          <unite-loading-button [disabled]="!shareholder.isValid()" icon="done" (click)="saveShareholder($any(applicant), shareholder)" [text]="'Save' | translate" color="primary" [loading]="shareholder.isSaving">
          </unite-loading-button>
        </div>
      </mat-action-row>
    </mat-expansion-panel>
  }
}
</mat-accordion>
</div>